module.exports = __webpack_public_path__ + "static/media/game-stars.50ba4499.gif";